module.exports = __webpack_public_path__ + "img/Background_Interests.fa051546.jpg";